import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import { Http } from "../../../helpers/Http.jsx";
import GestionDescuentosModal from "./GestionDescuentosModal.jsx";
import { Functions } from "../../../helpers/Functions.jsx";
import GestionPagosModal from "./GestionPagosModal.jsx";

const GestionTransaccionesModal = ({ show, onClose, showDescuento, showPagar, title, solicitudId, user, metodosPago, solicitud, setSolicitud }) => {
    const { handleSubmit: handleSubmitModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});

    const [dataDescuentos, setDataDescuentos] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [dataPagos, setDataPagos] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [showGestionDescuento, setShowGestionDescuento] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [initDataDescuentos, setInitDataDescuentos] = useState(CONFIGURACIONES.INIT.NULL);

    const [showGestionPago, setShowGestionPago] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [initDataPagos, setInitDataPagos] = useState(CONFIGURACIONES.INIT.NULL);
    const [cuotaEstadoId, setCuotaEstadoId] = useState(CONFIGURACIONES.INIT.NUMBER);
   
    const [dataCuotas, setDataCuotas] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [selectedId, setSelectedId] = useState(CONFIGURACIONES.INIT.NUMBER);

    const fnExtornarPago = async (itm) => {
        await Functions().extornoElement(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/extornar-pago/${itm.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_EXTORN_OPERATION, `${CONFIGURACIONES.MESSAGES.DELETES.TRANSACCIONES_PAGOS} Con Estado: <strong>${itm.estadoNombre}</strong>, Monto: <strong>${itm.montoTotal}</strong> y Fecha: <strong>${itm.fechaRegistro}</strong>`, user, fnReturnExtorno, {});
    };

    const fnExtornarDescuento = async (itm) => {
        await Functions().extornoElement(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/extornar-descuento/${itm.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_EXTORN_OPERATION, `${CONFIGURACIONES.MESSAGES.DELETES.TRANSACCIONES_DESCUENTO} De Tipo: <strong>${itm.tipo}</strong>, con Estado: <strong>${itm.estadoNombre}</strong>, Monto: <strong>${itm.monto}</strong> y Fecha: <strong>${itm.fechaRegistro}</strong>`, user, fnReturnExtorno, {});
    };

    const fnReturnExtorno = (data) => {
        setSolicitud(data.solicitud);
        setCuotaEstadoId(data.cuota_estado_id);
        setDataCuotas(data.cuotas);
        setDataDescuentos(data.descuentos);
        setDataPagos(data.pagos);
    };

    const loadDataSolicitud = () => {
        setSelectedId(CONFIGURACIONES.INIT.NUMBER);
        Http().get(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/${solicitudId}`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setSolicitud(rpta.data.solicitud);
                setDataCuotas(rpta.data.cuotas);
            } else {
                MySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `${Object.keys(rpta.errors).length?Functions().showErrors(rpta.errors):rpta.message}`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
        });
    };

    useEffect(() => {
        if (solicitudId !== CONFIGURACIONES.INIT.NUMBER) {
            loadDataSolicitud();
        }
    }, [solicitudId]);

    const loadDataCuote = (cuotaId) => {
        Http().get(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/${solicitudId}/ver-detalle/${cuotaId}`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setDataDescuentos(rpta.data.descuentos);
                setDataPagos(rpta.data.pagos);
                setCuotaEstadoId(rpta.data.cuota_estado_id);
            } else {
                MySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `${Object.keys(rpta.errors).length?Functions().showErrors(rpta.errors):rpta.message}`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
        });
    };


    const closeGestionDescuento = () => {
        setShowGestionDescuento(CONFIGURACIONES.INIT.STATUS_FALSE);
    }

    const closeGestionPago = () => {
        setShowGestionPago(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const handleCheck = (cuotaId) => {
        setSelectedId(cuotaId);
        loadDataCuote(cuotaId);
    };

    const fnModalDescuento = () => {
        if (selectedId !== CONFIGURACIONES.INIT.NUMBER && solicitudId !== CONFIGURACIONES.INIT.NUMBER) {
            Http().get(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/${solicitudId}/detalle-cuota/${selectedId}`).then((rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    setInitDataDescuentos(rpta.data.cuota);
                    setShowGestionDescuento(CONFIGURACIONES.INIT.STATUS_TRUE);
                } else {
                    MySwal.fire({
                        title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                        html: `${Object.keys(rpta.errors).length?Functions().showErrors(rpta.errors):rpta.message}`,
                        icon: 'error',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        cancelButtonColor: "#f62d51",
                        confirmButtonColor: "#2962FF"
                    });
                }
            });
        }
    };

    const fnModalPago = () => {
        if (selectedId !== CONFIGURACIONES.INIT.NUMBER && solicitudId !== CONFIGURACIONES.INIT.NUMBER) {
            Http().get(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/${solicitudId}/detalle-cuota/${selectedId}`).then((rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    setInitDataPagos(rpta.data.cuota);
                    setShowGestionPago(CONFIGURACIONES.INIT.STATUS_TRUE);
                } else {
                    MySwal.fire({
                        title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                        html: `${Object.keys(rpta.errors).length?Functions().showErrors(rpta.errors):rpta.message}`,
                        icon: 'error',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        cancelButtonColor: "#f62d51",
                        confirmButtonColor: "#2962FF"
                    });
                }
            });
        }
    };

    const saveGestionDescuento = async (form) => {
        if (!showDescuento) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/${solicitudId}/descuento-cuota/${selectedId}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnCloseGestionDescuentoWithReturn, form);
    };

    const fnCloseGestionDescuentoWithReturn = (data) => {
        setSolicitud(data.solicitud);
        setDataCuotas(data.cuotas);
        setCuotaEstadoId(data.cuota_estado_id);
        setDataDescuentos(data.descuentos);
        setDataPagos(data.pagos);
        setShowGestionDescuento(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const saveGestionPago = async (form) => {
        if (!showPagar) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/${solicitudId}/pagar-cuota/${selectedId}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnCloseGestionPagoWithReturn, form);
    };

    const fnCloseGestionPagoWithReturn = (data) => {
        setSolicitud(data.solicitud);
        setDataCuotas(data.cuotas);
        setCuotaEstadoId(data.cuota_estado_id);
        setDataDescuentos(data.descuentos);
        setDataPagos(data.pagos);
        setShowGestionPago(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const totalCapitalPendiente = useMemo(() => {
        return dataCuotas.reduce((prev, curr) => prev + parseFloat(curr.totalSaldos), 0);
    }, [dataCuotas]);

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-xxl modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        {solicitud && <div className="row">
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="numSolicitud" className="control-label col-form-label">Num. de Solicitud <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" id="numSolicitud" value={solicitud.numeroSolicitud} placeholder="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE} />
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="cliente" className="control-label col-form-label">Cliente <span className="text-danger">*</span></label>
                                    <input type="text" value={solicitud.cliente} className="form-control" id="cliente" placeholder="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE} />
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-2">
                                <div className="form-group">
                                    <label htmlFor="cuota" className="control-label col-form-label">Cuota <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" value={solicitud.cuota} id="cuota" placeholder="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE} />
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-2">
                                <div className="form-group">
                                    <label htmlFor="moneda" className="control-label col-form-label">Moneda <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" value={solicitud.moneda} id="moneda" placeholder="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE} />
                                </div>
                            </div>
                        </div>}
                        
                        <div className="row">
                            <div className="col-xs-12 col-md-6">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h6 className="text-success">Detalle de Cronograma</h6>
                                        <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
                                            <table className="table table-bordered compact-table align-middle text-nowrap">
                                                <thead className="table-warning">
                                                <tr>
                                                    <th className="text-center">Seleccionar</th>
                                                    <th>Nro</th>
                                                    <th>Fecha de Vencimiento</th>
                                                    <th>Descuentos</th>
                                                    <th>Mora</th>
                                                    <th>Saldo Pendiente</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {dataCuotas.length > 0? (
                                                    dataCuotas.map((el, index) => (
                                                        <React.Fragment key={index}>
                                                        <tr>
                                                            <td className="text-center">
                                                                <input type="radio" className="text-center" checked={el.id === selectedId} onChange={() => handleCheck(el.id)}/>
                                                            </td>
                                                            <td>{el.nroCuota}</td>
                                                            <td>{el.fechaVencimiento}</td>
                                                            <td>{el.totalDescuentos}</td>
                                                            <td>{el.montoMora}</td>
                                                            <td>{el.totalSaldos}</td>
                                                        </tr>
                                                        </React.Fragment>))
                                                ): (<tr><td className="align-middle p-2 bg-white text-danger font-bold" colSpan={6}>{CONFIGURACIONES.MESSAGES.LIST_EMPTY}</td></tr>)}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-4 pl-0">
                                    <div className="form-group">
                                        <label htmlFor="saldoPendiente" className="control-label col-form-label">Saldo Pendiente <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" id="saldoPendiente" value={totalCapitalPendiente} placeholder="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE} />
                                    </div>
                                </div>
                            </div>
                            {selectedId !== CONFIGURACIONES.INIT.NUMBER && <div className="col-xs-12 col-md-6">
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <h6 className="text-muted">Detalle de Pagos</h6>
                                        <div className="table-responsive" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                            <table className="table table-bordered compact-table align-middle text-nowrap">
                                                <thead className="table-warning">
                                                <tr>
                                                    <th>Fecha de Pago</th>
                                                    <th>Monto Pagado</th>
                                                    <th>Estado</th>
                                                    <th></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {dataPagos.length > 0? (
                                                    dataPagos.map((el, index) => (
                                                        <React.Fragment key={index}>
                                                        <tr>
                                                            <td>{el.fechaRegistro}</td>
                                                            <td>{el.montoTotal}</td>
                                                            <td>{el.estadoNombre}</td>
                                                            <td>
                                                                {((cuotaEstadoId !== CONFIGURACIONES.INIT.ESTADOS_CUOTA.ESTADO_PAGADO && el.estadoId !== CONFIGURACIONES.INIT.ESTADOS_CUOTA.ESTADO_EXTORNADO) || (cuotaEstadoId == CONFIGURACIONES.INIT.ESTADOS_CUOTA.ESTADO_PAGADO && el.estadoId == CONFIGURACIONES.INIT.ESTADOS_CUOTA.ESTADO_PAGADO)) && <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={() => fnExtornarPago(el)} dataTooltipId="extornar_transaccion" place="left" content="Extornar">
                                                                    <i className="mdi mdi-delete"></i>
                                                                </WaveButton>}
                                                            </td>
                                                        </tr>
                                                        </React.Fragment>))
                                                ): (<tr><td className="align-middle p-2 bg-white text-danger font-bold" colSpan={4}>{CONFIGURACIONES.MESSAGES.LIST_EMPTY}</td></tr>)}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <h6 className="text-danger">Detalle de Descuentos</h6>
                                        <div className="table-responsive" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                            <table className="table table-bordered compact-table align-middle text-nowrap">
                                                <thead className="table-warning">
                                                <tr>
                                                    <th className="text-center">Aplicado a</th>
                                                    <th>Monto</th>
                                                    <th>Estado</th>
                                                    {/* <th>Motivo</th> */}
                                                    {/* <th>Registrado Por</th> */}
                                                    <th>Registrado el</th>
                                                    <th></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {dataDescuentos.length > 0? (
                                                    dataDescuentos.map((el, index) => (
                                                        <React.Fragment key={index}>
                                                        <tr>
                                                            <td className="text-center">{el.tipo}</td>
                                                            <td>{el.monto}</td>
                                                            <td>{el.estadoNombre}</td>
                                                            {/* <td>{el.motivo}</td> */}
                                                            {/* <td>{el.usuarioRegistro}</td> */}
                                                            <td>{el.fechaRegistro}</td>
                                                            <td>
                                                                {cuotaEstadoId !== CONFIGURACIONES.INIT.ESTADOS_CUOTA.ESTADO_PAGADO && el.estadoId !== CONFIGURACIONES.INIT.ESTADOS_DESCUENTO.ESTADO_EXTORNADO && <WaveButton type="button" className="btn btn-sm btn-outline-danger" dataTooltipId="extornar_transaccion_pago" place="left" content="Extornar" onClick={() => fnExtornarDescuento(el)} >
                                                                    <i className="mdi mdi-delete"></i>
                                                                </WaveButton>}
                                                            </td>
                                                        </tr>
                                                        </React.Fragment>))
                                                ): (<tr><td className="align-middle p-2 bg-white text-danger font-bold" colSpan={5}>{CONFIGURACIONES.MESSAGES.LIST_EMPTY}</td></tr>)}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        {showPagar && <WaveButton type="button" className="btn btn-sm btn-success waves-effect" onClick={fnModalPago}>
                                            <i className="mdi mdi-cash"></i> Pagar / Amortizar
                                        </WaveButton>}

                                        {showDescuento && <WaveButton type="button" className="btn btn-sm btn-info waves-effect ml-2" onClick={fnModalDescuento}>
                                            <i className="mdi mdi-percent"></i> Generar Descuento
                                        </WaveButton>}
                                    </div>
                                </div>

                                <GestionDescuentosModal show={showGestionDescuento} onClose={closeGestionDescuento} onSave={saveGestionDescuento} showCreate={showDescuento} title={"Gestión de Descuentos"} initDataDescuentos={initDataDescuentos} />
                                <GestionPagosModal show={showGestionPago} onClose={closeGestionPago} onSave={saveGestionPago} showCreate={showPagar} title={"Gestión de Pagos"} initDataPagos={initDataPagos} metodosPago={metodosPago}/>
                            </div>}
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default GestionTransaccionesModal;
